var _feGaussianBlur;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189.101,
    height: 265.655,
    viewBox: "0 0 50.033 70.288",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "a",
    x: -0.09,
    y: -0.065,
    width: 1.181,
    height: 1.131
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.394
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.574359,
      filter: "url(#a)"
    },
    transform: "translate(.53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "gray",
      fillOpacity: 1,
      strokeWidth: 0.183637
    },
    d: "M38.055 9.628a6.285 6.122 0 0 0-6.285 6.122 6.285 6.122 0 0 0 6.285 6.121 6.285 6.122 0 0 0 6.285-6.121 6.285 6.122 0 0 0-6.285-6.122zm0 2.17a4.056 3.95 0 0 1 4.056 3.952 4.056 3.95 0 0 1-4.056 3.95 4.056 3.95 0 0 1-4.056-3.95 4.056 3.95 0 0 1 4.056-3.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "gray",
      fillOpacity: 1,
      strokeWidth: 0.237801
    },
    d: "M24.584 20.522c-1.778.024-3.608.255-4.853.668-5.76 1.912-9.949 7.074-10.745 13.243-.242 1.873-.3 2.013-.88 2.152-.95.226-.957.242-.58 1.45.342 1.096.315 3.96-.048 5.187-.138.466-.05.492 1.713.508 3.228.03 6.11 1.029 9.449 3.276 4.144 2.79 8.575 5.605 10.833 10.318l.825 1.723.434-1.262c1.18-3.434 2.781-8.953 2.788-11.374.002-.726-.116-.9-.886-1.307-1.223-.647-3.69-3.15-4.099-4.16-.417-1.028-.625-1.176-1.67-1.185-.458-.004-.983-.103-1.167-.22-.49-.31 2.397-.57 5.049-.454 1.819.08 2.45.216 3.586.771 3.082 1.508 3.692 5.532 1.82 10.13l-.676 1.663.647.891c.355.49 1.066 1.26 1.58 1.71l.932.82.164-1.414c.09-.777.339-3.018.553-4.98.666-6.103 1.461-15.486 3.082-20.423.339-1.031.562-1.928.497-1.993-.065-.065-1.272.215-2.683.623-6.56 1.895-14.253 4.448-14.93 4.69-.322.115-.399.092-.238-.072.196-.2 7.398-3.447 10.939-4.932l.951-.398-1.548-1.473c-1.838-1.75-4.603-3.249-7.087-3.844-1.02-.244-2.37-.35-3.752-.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "gray",
      fillOpacity: 1,
      strokeWidth: 0.239506
    },
    d: "M31.445 7.767c-10.98.635-19.463 6.377-22.909 16.846-.422 1.311-1.183 5.483-1.158 6.347.006.197.264-.302.575-1.11 1.491-3.873 4.757-7.412 8.522-9.237 2.922-1.417 4.81-1.868 7.812-1.868 2.783 0 5.148.523 7.596 1.68.89.42 1.646.726 1.68.68.003-.005.016-.045.023-.064-1.774-1.273-2.82-3.275-2.821-5.4 0-3.729 3.148-6.75 7.03-6.75a7.3 7.3 0 0 1 2.134.32c.002-.008.009-.02.009-.024 0-.466-4.348-1.284-7.425-1.397a33.998 33.998 0 0 0-1.068-.023z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60981b",
      fillOpacity: 1,
      strokeWidth: 0.183637
    },
    d: "M37.526 9.628a6.285 6.122 0 0 0-6.286 6.122 6.285 6.122 0 0 0 6.286 6.121 6.285 6.122 0 0 0 6.285-6.121 6.285 6.122 0 0 0-6.285-6.122zm0 2.17a4.056 3.95 0 0 1 4.056 3.952 4.056 3.95 0 0 1-4.056 3.95 4.056 3.95 0 0 1-4.056-3.95 4.056 3.95 0 0 1 4.056-3.951z",
    transform: "translate(-.53)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006241",
      fillOpacity: 1,
      strokeWidth: 0.237801
    },
    d: "M24.055 20.522c-1.778.024-3.608.255-4.854.668-5.76 1.912-9.948 7.074-10.744 13.243-.242 1.873-.3 2.013-.88 2.152-.95.226-.957.242-.58 1.45.342 1.096.315 3.96-.048 5.187-.139.466-.051.492 1.713.508 3.228.03 6.11 1.029 9.448 3.276 4.145 2.79 8.576 5.605 10.834 10.318l.825 1.723.434-1.262c1.18-3.434 2.78-8.953 2.788-11.374.002-.726-.116-.9-.887-1.307-1.222-.647-3.69-3.15-4.098-4.16-.417-1.028-.625-1.176-1.67-1.185-.458-.004-.983-.103-1.167-.22-.49-.31 2.397-.57 5.048-.454 1.82.08 2.451.216 3.586.771 3.083 1.508 3.693 5.532 1.822 10.13l-.677 1.663.646.891c.356.49 1.067 1.26 1.58 1.71l.933.82.164-1.414c.09-.777.339-3.018.553-4.98.666-6.103 1.461-15.486 3.082-20.423.339-1.031.562-1.928.497-1.993-.065-.065-1.272.215-2.683.623-6.56 1.895-14.253 4.448-14.93 4.69-.322.115-.399.092-.238-.072.196-.2 7.398-3.447 10.939-4.932l.951-.398-1.548-1.473c-1.838-1.75-4.603-3.249-7.088-3.844-1.018-.244-2.37-.35-3.752-.332z",
    transform: "translate(-.53)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e02c1e",
      fillOpacity: 1,
      strokeWidth: 0.239506
    },
    d: "M30.916 7.767c-10.98.635-19.463 6.377-22.909 16.846-.422 1.311-1.183 5.483-1.158 6.347.005.197.264-.302.575-1.11 1.491-3.873 4.757-7.412 8.521-9.237 2.923-1.417 4.81-1.868 7.812-1.868 2.783 0 5.15.523 7.597 1.68.89.42 1.646.726 1.68.68.003-.005.016-.045.023-.064-1.774-1.273-2.82-3.275-2.821-5.4 0-3.729 3.148-6.75 7.03-6.75a7.3 7.3 0 0 1 2.134.32c.002-.008.009-.02.009-.024 0-.466-4.348-1.284-7.425-1.397a33.998 33.998 0 0 0-1.068-.023z",
    transform: "translate(-.53)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ea634d2bc7606648716441c378100fbd.svg";
export { ForwardRef as ReactComponent };